module.exports = __webpack_public_path__ + "img/gw3.9d1c2fd2.png";